<template>
  <div>
    <div class="button is-small lock" @click="handleClick()">Neuer Auftrag</div>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean
  },
  methods: {
    handleClick () {
      if (!this.loading) {
        this.currentStep = 'SCAN_ORDER'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.button.lock
  height: 35px
</style>
